// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"5eea1d0b","160":"ed5e19cb","189":"59a3c122","216":"3f4ca073","236":"dbcdf0c9","281":"e9cf5196","449":"812875c9","533":"54113d37","544":"2e963927","566":"b824a542","722":"bf2a92dc","846":"937486c7","962":"0664e2d5","977":"8e97521d"}[chunkId] + ".chunk.js";
};